module.exports = __webpack_public_path__ + "static/media/62_tn.34a7f40a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/62_tn.jpg
// module id = 549
// module chunks = 0